import React, { useState } from "react";
import "./BottomNavContentPlan.css";
import { Collapse, Card, Space, Typography } from "antd";
import { PlanCard } from "./PlanCard";

const DropdownContent = ({ icon, color, items, fbPageId, snTokens }) => {
    const [open, setOpen] = useState(false);
    if (!items?.length) return null;

    return (
        <Card
            className="shadow-sm"
            bordered
            bodyStyle={{ padding: 12 }}
            style={{ background: "rgba(238,235,255,1)" }}
        >
            <Collapse
                ghost
                activeKey={open ? ["sn"] : []}
                onChange={() => setOpen(!open)}
                items={[
                    {
                        key: "sn",
                        label: (
                            <Space align="center" style={{ width: "100%", justifyContent: "space-between" }}>
                                <Space size={10}>
                                    <img src={icon} alt="" style={{ width: 20, height: 20 }} />
                                    <Typography.Text strong style={{ color }}>{/* keep color hook */}
                                        {items?.[0]?.socialNetwork || "Social Network"}
                                    </Typography.Text>
                                </Space>
                                <Typography.Text type="secondary">
                                    {open ? "Hide" : "Show"}
                                </Typography.Text>
                            </Space>
                        ),
                        children: (
                            <div className="items-container">
                                {items.map((item, index) => (
                                    <PlanCard
                                        fbPageId={fbPageId}
                                        key={item.id}
                                        item={item}
                                        index={index}
                                        snTokens={snTokens}
                                    />
                                ))}
                            </div>
                        ),
                    },
                ]}
            />
        </Card>
    );
};

export default DropdownContent;
